import { TabList } from '@fiverr-private/navigation';

export default TabList;
